import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GridService {
  private apiUrl = environment.apiUrl; // Adjust the base URL as necessary

  constructor(private http: HttpClient) { }

  getLanguages(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}Accounts/GetLanguages/`);
  }

  getLanguageTranslations(lang): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}Accounts/GetLanguageTranslations/${lang}`);
  }

  getScopeView(ViewCode: string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}View/GetScopeView/${ViewCode}`);
  }

  GetScopeFieldForView(fieldCode: string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}View/GetScopeFieldForView/${fieldCode}`);
  }
  getComponentView(ViewCode: string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}View/GetScopeComponentView/${ViewCode}`);
  }

  getScopeData(scopeCode: string, commandName: string, requestData: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}DrakeData/GetScopeData/${scopeCode}/${commandName}`, requestData);
  }
  getScopeDataSimple(scopeCode: string, commandName: string, requestData: any): Observable<any> {
    var scopeData = this.http.post(`${this.apiUrl}DrakeData/GetScopeDataSimple/${scopeCode}/${commandName}`, requestData);
    //console.log("scopeData:")
    //console.log(scopeData)
    return scopeData
  }
  getDropDownValues(fieldCode: string): Observable<any> {
    var drpData = this.http.get(`${this.apiUrl}DrakeData/GetDropDownValues/${fieldCode}`);
    return drpData;
  }
  saveScopeData(scopeCode: string, commandName: string, requestData: any, isDraft: boolean) {
    var scopeData = this.http.post(`${this.apiUrl}DrakeData/WriteScopeData/${scopeCode}/${commandName}`, { Data: [requestData], forceValues: false, isDraft: isDraft })
    console.log("requestData", requestData);
    return scopeData
  }

  updateScopeData(scopeCode: string, commandName: string, data: any, query: any, isDraft: boolean) {
    var scopeData = this.http.post(`${this.apiUrl}DrakeData/BulkUpdate/${scopeCode}/${commandName}`, { Data: data, Query: query, forceValues: false, isDraft: isDraft })
    console.log("requestData", data);
    return scopeData
  }

  cloneScopeData(scopeCode: string, commandName: string, requestData: any) {
    var clonedData = { ...requestData, _id: null };
    return this.http.post(`${this.apiUrl}DrakeData/WriteScopeData/${scopeCode}/${commandName}`, { Data: [clonedData], forceValues: false, isDraft: false });
  }

  deleteScopeData(scopeCode: string, commandName: string, requestData: any) {
    const body = {
      forceValues: true,
      isDraft: false,
      query: requestData,
      limit: 1
    };
    const options = {
      body: body
    };
    var scopeData = this.http.request('delete', `${this.apiUrl}DrakeData/WriteScopeData/${scopeCode}/${commandName}`, options);
    return scopeData;
  }


  getGlobalSearchData(query: string): Observable<any> {
    var searchData = this.http.get(`${this.apiUrl}DrakeData/GetGlobalSearchData/${query}`);
    return searchData;
  }

  getImage(relativeUrl: string) {
    return this.http.get(`${this.apiUrl}${relativeUrl.substring(1)}`);
  }

  downloadFile(id: string) {
    return this.http.get<any[]>(`${this.apiUrl}drakeData/ReadFileAsBase64String/${id}}`, {});
  }

  getComponent(code: string) {
    return this.http.get<any>(`${this.apiUrl}Component/GetComponentDto/${code}`, {});
  }

  AssociateDomCode(code: string, userId: string): Observable<any> {
    const body = {
      Code: code,
      UserId: userId,
    };
    var association = this.http.post<any[]>(`${this.apiUrl}Accounts/AssociateDomCode/`, body);
    return association;
  }
}
